export default __webpack_public_path__ + "static/media/wennliebekommt.4505fd49.mp3";